/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AppEnvironmentStrictHttpResponse } from '../../app-environment-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CountryItemModel } from '../../models/country-item-model';

export interface AppEnvironmentCountriesGet$Params {
}

export function appEnvironmentCountriesGet(http: HttpClient, rootUrl: string, params?: AppEnvironmentCountriesGet$Params, context?: HttpContext): Observable<AppEnvironmentStrictHttpResponse<Array<CountryItemModel>>> {
  const rb = new RequestBuilder(rootUrl, appEnvironmentCountriesGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AppEnvironmentStrictHttpResponse<Array<CountryItemModel>>;
    })
  );
}

appEnvironmentCountriesGet.PATH = '/AppEnvironment/Countries';
